import { API_URL } from '../../../app-config/constants';
import { EmailConfigurationDto } from '../../../types/EmailConfigurationDto';
import { get, put } from '../request';

export function getEmailConfiguration(): Promise<EmailConfigurationDto> {
    return get(`${API_URL}/email-configuration`);
}

export function saveEmailConfiguration(emailConfiguration: EmailConfigurationDto): Promise<EmailConfigurationDto> {
    return put(`${API_URL}/email-configuration`, {
        postData: emailConfiguration,
    });
}
